import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { RevxsSizeRadioGroup } from 'components/RevxSizeRadioGroup';
import { JobSpec } from 'domains/jobconfigDomain';
import { SKU } from 'domains/skuDomain';
import { useTranslation } from 'react-i18next';
import { PLATFORM_FORM_ITEM_LAYOUT } from 'utils/constants';

export const SkuTesterStepFinishedSize = ({
  sku,
  spec,
}: {
  sku: SKU;
  spec: JobSpec;
}) => {
  const [form] = useForm();
  const { t } = useTranslation();

  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <>
      <div className="sku-tester-wizard-step-title">
        {t('platform.sku.tester.stepFinishedSize.pageTitle')}
      </div>
      <div className="sku-tester-wizard-step-content">
        <Form
          layout={'horizontal'}
          form={form}
          {...PLATFORM_FORM_ITEM_LAYOUT}
          onFinish={onFinish}
          autoComplete="off"
          onValuesChange={(values) => {
            console.log('onValues Change', values);
          }}
          initialValues={{ flatSize: spec.flatSizeIn }}
        >
          <Form.Item name="flatSize">
            <RevxsSizeRadioGroup
              options={sku.skuSizes.filter(
                (size) => size.orientation === spec.orientation
              )}
              onChange={onFinish}
            />
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
